import Vue from 'vue';
import { formatPrice, _log } from './util';

document.addEventListener('DOMContentLoaded', function() {
    startRetailers();
});

function startRetailers()
{
    const el = document.getElementById("vue_gm");
    if (!el) {
        return false;
    }
    new Vue({
        el: '#vue_gm',
        delimiters: ['[[',']]'],
        data: {
            countryList : null,
            cityName : "",
            cityList : null,
            cityOptions : [],
            retailers : [],
            retailerIds : [],
            retailerList : [],
            boutiqueList : [],
            ccByQuery : false,
            today : new Date()
        },

        methods :
        {
            isBoutique : function(item)
            {
                return (item.type==='boutique');
            },

            buildTelLink : function (item, prefix=true)
            {
                /*const countryCallCode  = (item.country_call_code) ? item.country_call_code : "";
                const cityCode         = (item.city_code) ? item.city_code : "";*/
                const phone            = (item.phone) ? item.phone.replace(" ", "") : "";

                //const phoneNumber = countryCallCode+cityCode+phone;

                return (prefix) ? 'tel:'+phone : phone;
            },

            buildFaxLink : function (item, prefix=true)
            {
                const countryCallCode  = (item.country_call_code) ? item.country_call_code : "";
                const cityCode         = (item.city_code) ? item.city_code : "";
                const phone            = (item.fax) ? item.fax.replace(" ", "") : "";

                const faxNumber = countryCallCode+cityCode+phone;

                return (prefix) ? 'fax:'+faxNumber : faxNumber;
            },

            buildMailtoLink : function (item)
            {
                return 'mailto:' +item.email;
            },

            buildRouteLink : function (item)
            {
                let home = '';
                if (this.center && this.center.lat) {
                    home = `${this.center.lat}, ${this.center.lng}`;
                }
                return `https://www.google.com/maps/dir/?api=1&origin=${home}&destination=${item.lat}, ${item.lng}`;
            },

            toggleLayer: function( id )
            {
                const card = document.getElementById('retailer-'+id);
                card.classList.toggle("active");
            },


            toggleRetailerInfo( key, forced )
            {
                let element = document.getElementById("retailer-"+key);
                // continue only if element is visible
                if (element !== null) {
                    if (element.classList.contains("show")) {
                        element.classList.remove("show");
                        this.infoOpened = false;
                    } else {
                        $(".retailer").removeClass("show");
                        element.classList.add("show");

                        if (typeof forced === 'undefined') {
                            this.openInfo(key, true);
                        }
                    }
                }
            },

            submitContact : function ( event )
            {
                // _log("submit contact ...")
                event.preventDefault();

                let request_data = {
                    // _token: csrf_token,
                    // token: csrf_token,
                    locale          : this.contact_locale,
                    retailer_id     : this.contact_retailer_id,
                    name            : this.contact_name,
                    email           : this.contact_email,
                    phone           : this.contact_phone,
                    message         : this.contact_message
                };

                // console.log(this.contact_api_url);
                // console.log(request_data);
                $.ajax({
                        url: this.contact_api_url,
                        type: 'POST',
                        data: request_data,
                        dataType: 'JSON',
                        success: this.sendContactForm__Callback,
                        error: function() {
                            console.log("error");
                        }
                    }
                );
            },

            sendContactForm__Callback : function ( response )
            {
                if (typeof response === "object") {
                    this.contact_response = response.message;
                }
            },

            getRetailers : function()
            {
                const date = new Date();

                const request_data = {
                    action: 'get_retailers',
                    locale: locale,
                    t: date.getTime(),
                };

                $.ajax({
                    url: xhrUrl,
                    type: 'GET',
                    data: request_data,
                    dataType: 'JSON',
                    success: this.getRetailers__callback,
                });
            },

            getRetailers__callback : function(response)
            {
                if (typeof response === "object") {
                    this.countryList = response.countryList;
                    this.retailers = response.retailers;
                    this.updateCityList();
                }
            },

            getFirstKey : function(data) {
                for (var prop in data) {
                    return prop;
                }
            },


            setLocationByRetailerId : function( retailerId )
            {
                let countryCode = null;
                let cityName = null;
                let cityValue = null;
                let cityOptions = null;

                for(let i=0;i<this.retailers.items.length;i++) {
                    let country = this.retailers.items[i];
                    // check for first boutique in selected country
                    for (let c=0; c<country.retailers.length;c++) {
                        if (country.retailers[c].id == retailerId) {
                            cityOptions = country.cities;
                            countryCode = country.retailers[c].country_code;
                            cityName    = country.retailers[c].city;
                            cityValue   = country.retailers[c].city_slug;
                            this.ccByQuery = true;
                            break;
                        }
                    }

                    if (this.ccByQuery) {
                        this.cityOptions = cityOptions;
                        this.countryList = countryCode;
                        this.cityList = cityValue;
                        this.cityName = cityName;
                        break;
                    }
                }

            },


            resetCustomRetailerIds : function()
            {
                this.retailerIds = [];
                this.ccByQuery = false;
            },


            updateCityList : function( reset=false )
            {

                if (reset===true) {
                    this.resetCustomRetailerIds();
                }

                if (this.retailerIds.length) {
                    this.setLocationByRetailerId(this.retailerIds[0]);
                }

                if (!this.ccByQuery) {
                    for(let i=0;i<this.retailers.items.length;i++) {
                        if (this.retailers.items[i].cc === this.countryList) {
                            const country = this.retailers.items[i];
                            // update city options in select tag
                            this.cityOptions = country.cities;
                            // set first city as default
                            this.cityList = this.getFirstKey(this.cityOptions);
                            this.cityName = this.cityOptions[this.cityList];
                            // check for first boutique in selected country
                            for (let c=0; c<country.retailers.length;c++) {
                                if (country.retailers[c].type === "boutique") {
                                    this.cityList = country.retailers[c].city_slug;
                                    this.cityName = country.retailers[c].city;
                                }
                                break;
                            }

                            break;
                        }
                    }
                }


                // this.cityList  = "Dresden";
                this.updateRetailerList();
            },


            updateRetailerList : function() {
                let retailerList = [];
                let boutiqueList = [];

                // this.retailers = all retailers grouped by country code
                for(let i=0;i<this.retailers.items.length;i++) {
                    if (this.retailers.items[i].cc === this.countryList) {

                        // loop through current country code
                        const localRetailers = this.retailers.items[i].retailers;
                        for(let c=0; c<localRetailers.length; c++) {

                            if (this.ccByQuery && this.retailerIds.length) {
                                if (this.retailerIds.indexOf(String(localRetailers[c].id)) === -1) {
                                    continue;
                                }
                            }

                            let retailerCity = localRetailers[c].city_slug;
                            if(retailerCity) {
                                if (retailerCity === this.cityList) {
                                    let theRetailer = localRetailers[c];
                                    theRetailer.todayId = this.getDayOfTheWeek();
                                    this.cityName = theRetailer.city;
                                    // _log(theRetailer.todayId);
                                    if (this.isBoutique(theRetailer)) {
                                        // _log("is b");
                                        boutiqueList.push(theRetailer);
                                    } else {
                                        // _log("is r");
                                        retailerList.push(theRetailer);
                                    }
                                }
                            } else {
                                _log("missing city")
                                _log(localRetailers[c]);
                            }


                        }
                        break;
                    }
                }

                this.retailerList = retailerList;
                this.boutiqueList = boutiqueList;

                this.resetCustomRetailerIds();
            },

            getDayOfTheWeek : function() {
                const mapping = {
                    0 : 6, // So
                    1 : 0,  // Mo
                    2 : 1, // Di
                    3 : 2, // Mi
                    4 : 3, // Do
                    5 : 4, // Fr
                    6 : 5, // Sa
                };
                const today = this.today.getDay();
                return mapping[today];
            },

            setDefaultRetailers : function()
            {
                const queryString = document.location.search.replace("?", '');
                const keyValue = queryString.split("=");
                if (typeof keyValue === "object" && keyValue[0] === "id" && keyValue[1]) {
                    this.retailerIds = keyValue[1].split(",");
                }
            },

            maybePrefillForm : function(item) {
                if(item.prefill_form_country && item.prefill_form_boutique) {
                    var selectCountry = document.getElementById("input_23_19");
                    var selectBoutique = document.getElementById("input_23_26");

                    selectCountry.value = item.prefill_form_country;
                    selectBoutique.value = item.prefill_form_boutique;
                  

                    var event = new Event('change', {
                      'bubbles': true,
                      'cancelable': true
                    });

                    selectCountry.dispatchEvent(event);   
                    selectBoutique.dispatchEvent(event);                   
                }
            }
        },
        created : function()
        {
            //this.setDefaultRetailers();
            this.getRetailers();
        },


    });
}